import React from "react";
import { ROLE_LABEL } from "@/lib/utils-cart";

export function PaymentStatusBadge({ status, testid }) {
  const map = {
    paid: "bg-accent-green/10 text-accent-green border-accent-green/30",
    completed: "bg-accent-green/10 text-accent-green border-accent-green/30",
    pending: "bg-amber-500/10 text-amber-700 border-amber-500/30",
    failed: "bg-destructive/10 text-destructive border-destructive/30",
    cancelled: "bg-muted text-muted-foreground border-border",
    refunded: "bg-slate-200 text-slate-700 border-slate-300",
    partially_refunded: "bg-slate-100 text-slate-700 border-slate-300",
    chargeback: "bg-destructive/10 text-destructive border-destructive/30",
  };
  const cls = map[status] || "bg-muted text-muted-foreground border-border";
  return (
    <span
      data-testid={testid || `payment-status-${status}`}
      className={`inline-flex items-center rounded-sm border px-2 py-0.5 font-mono text-[10px] tracking-wider uppercase ${cls}`}
    >
      {String(status || "—").replace("_", " ")}
    </span>
  );
}

export function GatewayBadge({ gateway, testid }) {
  if (!gateway) return null;
  const styles = {
    square: { bg: "#0D1117", text: "white", label: "SQUARE" },
    paypal: { bg: "#003087", text: "white", label: "PAYPAL" },
    manual: { bg: "#475569", text: "white", label: "MANUAL" },
    internal: { bg: "#0F2A5C", text: "white", label: "INTERNAL" },
  };
  const s = styles[gateway] || styles.manual;
  return (
    <span
      data-testid={testid || `gateway-${gateway}`}
      style={{ backgroundColor: s.bg, color: s.text }}
      className="inline-flex items-center rounded-sm px-2 py-0.5 text-[10px] font-mono font-semibold tracking-wider"
    >
      {s.label}
    </span>
  );
}

export function RoleBadge({ role }) {
  return (
    <span className="inline-flex items-center rounded-sm border border-primary/20 bg-primary/5 px-2 py-0.5 font-mono text-[10px] tracking-[0.2em] uppercase text-primary">
      {ROLE_LABEL[role] || role}
    </span>
  );
}

export function StatusPill({ children, tone = "default" }) {
  const tones = {
    default: "bg-muted text-muted-foreground border-border",
    success: "bg-accent-green/10 text-accent-green border-accent-green/30",
    warning: "bg-amber-500/10 text-amber-700 border-amber-500/30",
    danger: "bg-destructive/10 text-destructive border-destructive/30",
    info: "bg-accent-blue/10 text-accent-blue border-accent-blue/30",
  };
  return (
    <span className={`inline-flex items-center rounded-sm border px-2 py-0.5 text-[11px] font-medium ${tones[tone]}`}>
      {children}
    </span>
  );
}
